export const INTERVIEW_FEEDBACK_SCORE_MODEL = "interview-feedback-score";
import { INTERVIEW_FORMAT_CRITERIA_MODEL } from "@/models/interview-format-criteria-model";

const interviewFeedbackScoreModel = {
  score: "",
  criteria: {
    jsonApi: "hasOne",
    type: INTERVIEW_FORMAT_CRITERIA_MODEL
  }
};

export default interviewFeedbackScoreModel;
